/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * RefreshIcon
 */
export default class RefreshIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M23 3c-.6 0-1 .4-1 1v3.7l-2.9-2.8c-.8-.8-2.1-1.8-3.7-2.3-5.3-1.8-11 .8-12.8 6.1-.2.5 0 1.1.6 1.2.5.2 1.1-.1 1.3-.6C6 5.2 10.5 3 14.7 4.5c1 .3 1.9.9 3 1.9L20.5 9H17c-.6 0-1 .4-1 1s.4 1 1 1h6c.1 0 .3 0 .4-.1.1-.1.2-.1.3-.2 0 0 0-.1.1-.1 0-.1.1-.1.1-.2v-.2V4c.1-.6-.3-1-.9-1zm-2.3 11c-.5-.2-1.1.1-1.2.7-.3 1.1-1 2.1-1.9 3-3.1 3.1-8.2 3.1-11.3 0L3.5 15H7c.6 0 1-.4 1-1s-.4-1-1-1H1c-.1 0-.2 0-.3.1H.6s-.1 0-.1.1c-.1 0-.2.1-.2.2 0 0 0 .1-.1.1 0 .1-.1.1-.1.2V20c0 .6.4 1 1 1s1-.4 1-1v-3.7L5 19.1C6.9 21 9.5 22 12.1 22c2.6 0 5.1-1 7.1-2.9 1.1-1.1 1.9-2.4 2.3-3.8 0-.5-.3-1.1-.8-1.3z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

